import type { NavigationGuard } from "vue-router";
import { AuthStoreModule } from "@/modules/auth/store/auth.store";

export const authGuard: NavigationGuard = (to, from, next) => {
  if (to.matched.some((route) => route.meta?.requiresAuth) && !AuthStoreModule.isAuthenticated) {
    next({
      name: "AuthLogin",
    });
    return;
  }
  next();
};
